import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

//inventory
export const getInventoryCertificationList = createAsyncThunk(
  "getInventoryCertificationList",
  async (type) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/inventory/group?type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getInventoryList = createAsyncThunk(
  "getInventoryList",
  async (idData) => {
    let { unitId, programId, heapId } = idData;
    try {
      const token = localStorage.getItem("cu_user");
      const heapIdQueryParam = heapId ? `&heapId=${heapId}` : "";
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/inventory?unitId=${unitId}&programId=${programId}${heapIdQueryParam}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getInventoryDetails = createAsyncThunk(
  "getInventoryDetails",
  async (inventoryId) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/inventory/${inventoryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

const InventorySlice = createSlice({
  name: "inventory",
  initialState: {
    cardList: [],
    list: [],
    details: null,
    status: "idle",
    error: null,
    isloading: true,
  },
  reducers: {},
  extraReducers: {
    [getInventoryCertificationList.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getInventoryCertificationList.fulfilled]: (state, action) => {
      state.status = "success";
      state.cardList = action.payload;
      state.isloading = false;
    },
    [getInventoryCertificationList.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },

    [getInventoryList.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getInventoryList.fulfilled]: (state, action) => {
      state.status = "success";
      state.list = action.payload;
      state.isloading = false;
    },
    [getInventoryList.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
      state.isloading = true;
    },

    [getInventoryDetails.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getInventoryDetails.fulfilled]: (state, action) => {
      state.status = "success";
      state.details = action.payload;
      state.isloading = false;
    },
    [getInventoryDetails.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
      state.isloading = true;
    },
  },
});

export default InventorySlice.reducer;
